module.exports = __webpack_public_path__ + "img/regular_retrofit.5227c83e.svg";